if (!customElements.get('product-form-component')) {
    class productFormComponent extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.formSubmitButton = this.querySelector(`button[form="${this.dataset.formId}"]`);
            // Never let a missing/!malformed payload abort the constructor — a failed upgrade is
            // permanent and silently degrades add-to-cart to a full-page form POST.
            const optionJsonEl = this.querySelector('.product-option-json');
            try {
                this.productData = optionJsonEl ? JSON.parse(optionJsonEl.textContent) : {};
            } catch (e) {
                console.error('product-form-component: invalid .product-option-json', e);
                this.productData = {};
            }
            this.productHandle = this.productData.handle;
            this.hasFreeProduct = this.hasAttribute('data-has-free-product');
            this.isAnytimeLink = this.hasAttribute('data-onetime-link');

            this.subscriptionSelector = this.querySelector('subscription-selector');
            this.init();


            // subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
            //     // Always call updateServing regardless of quantity value
            //     this.changeIdOnVariantChange(event);
            // });
        }

        init() {

            this.oneTimeSelectionCheck();
            const _this = this;

            if (this.form) {
                this.form.addEventListener('submit', async (e) => {
                    e.preventDefault();
                    const cartDrawer = document.querySelector('cart-drawer');

                    const freeProductsAdded = cartDrawer ? cartDrawer.querySelectorAll('[data-free-product-added]') : [];
                    const existingFreeIds = new Set(Array.from(freeProductsAdded).map(el => String(el.getAttribute('data-free-product-added') || '')));
                    const existingFreeHandles = new Set(Array.from(freeProductsAdded).map(el => String(el.getAttribute('data-free-product-handle') || '')));

                    // Inside the submit event listener function:

                    // const cartDrawer = document.querySelector('cart-drawer');

                    if (cartDrawer) {
                        const freeProductsAdded = cartDrawer.querySelectorAll('[data-free-product-added]') || [];
                        const existingFreeIds = new Set(Array.from(freeProductsAdded).map(el => String(el.getAttribute('data-free-product-added') || '')));
                        const existingFreeHandles = new Set(Array.from(freeProductsAdded).map(el => String(el.getAttribute('data-free-product-handle') || '')));

                        // Continue with your logic for cart handling here
                    } else {
                        console.warn('cart-drawer element not found');
                        // Handle the situation where cart-drawer is missing or handle alternative UI logic
                    }



                    // Get selected selling plan
                    const sellingPlanInput = _this.querySelector('input[name="selling_plan"]:checked') || _this.querySelector('input[name="selling_plan"]');
                    const sellingPlan = sellingPlanInput && sellingPlanInput.value !== '' ? sellingPlanInput.value : null;


                    // Collect all items using FormData
                    const items = this.collectItemsFromFormData();

                    // Add selling plan to each item if selected
                    if (sellingPlan) {
                        items.forEach(item => {
                            if (item.quantity > 0) {
                                item.selling_plan = sellingPlan;
                            }
                        });
                    }

                    // Add only missing free products
                    if (this.hasFreeProduct && sellingPlan !== null) {
                        const freeProductInputs = _this.querySelectorAll('input[name="free-product-id"]');
                        freeProductInputs.forEach((input) => {
                            const freeProduct = String(input.value || '');
                            const freeProductHandle = String(input.getAttribute('data-free-product-handle') || '');
                            if (!freeProduct) return;
                            if (existingFreeHandles.has(freeProductHandle)) return; // already in cart, skip
                            if (existingFreeIds.has(freeProduct)) return; // already in cart, skip

                            const hasSellingPlan = input.hasAttribute('data-has-selling-plan');
                            const sellingPlanId = input.getAttribute('data-has-selling-plan');

                            items.push({
                                id: freeProduct,
                                quantity: 1,
                                selling_plan: hasSellingPlan ? sellingPlanId : null,
                                properties: { _pack: this.productHandle }
                            });
                        });
                    }

                    // Filter out items with null id
                    const validItems = items.filter(item => item.id !== null);

                    this.formSubmitButton.setAttribute('aria-disabled', true);
                    this.formSubmitButton.classList.add('loading');
                    this.formSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');

                    // Build payload with proper section handling
                    const payload = _this.cart ? { items: validItems, sections: _this.cart.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname } : { items: validItems };

                    // Submit to Shopify
                    fetch(window.Shopify.routes.root + `cart/add.js`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json' // important!
                        },
                        body: JSON.stringify(payload)
                    })
                        .then(response => {
                            console.log('Cart response:', response);
                            if (!response.ok) throw new Error('Failed to add to cart');
                            return response.json(); // this includes `sections` key
                        })
                        .then((response) => {
                            console.log('Cart response:', response);
                            _this.cart.classList.toggle('is-empty', response.item_count === 0);
                            _this.cart.renderContents(response);
                        }).catch((error) => {
                            console.error('Cart error:', error);
                        }).finally(() => {
                            _this.formSubmitButton.removeAttribute('aria-disabled');
                            _this.formSubmitButton.classList.remove('loading');
                            _this.formSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
                            // _this.onSundaneAddPixel();
                        });
                });
            }
        }

        // onSundaneAddPixel() {
        //     const transactionId = localStorage.getItem('sd_transaction_id');

        //     if (transactionId) {
        //         const iframeSrc = `https://www.b7nmjklq4zx.com/?nid=2737&event_id=30680&oid=10918&transaction_id=${transactionId}`;

        //         if (document.querySelectorAll(`iframe[src="${iframeSrc}"]`).length != 0) return;

        //         const iframe = document.createElement('iframe');
        //         iframe.src = iframeSrc;
        //         iframe.width = "1";
        //         iframe.height = "1";
        //         iframe.frameBorder = "0";
        //         iframe.scrolling = "no";
        //         document.body.appendChild(iframe);

        //         console.log(iframe);
        //     }
        // }

        oneTimeSelectionCheck() {
            if (!this.subscriptionSelector) return;
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('product-type')) {
                const value = urlParams.get('product-type');
                if (value === 'one-time') {
                    console.log('works')
                    this.subscriptionSelector.querySelector('label[for="selling_plan_onetime"]').click();
                }
            }
        }

        collectItemsFromFormData() {
            const formData = new FormData(this.form);
            const items = [];
            const itemMap = new Map();

            // First pass: collect all item keys
            for (const key of formData.keys()) {
                const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
                if (match) {
                    const index = match[1];
                    const field = match[2];

                    if (!itemMap.has(index)) {
                        itemMap.set(index, {});
                    }

                    itemMap.get(index)[field] = formData.get(key);
                }
            }

            // Second pass: build items array
            for (const [index, item] of itemMap.entries()) {
                const quantity = parseInt(item.quantity) || 0;
                if (quantity > 0) {
                    items.push({
                        id: item.id,
                        quantity: quantity
                    });
                }
            }

            return items;
        }
    }


    customElements.define('product-form-component', productFormComponent);
}

if (!customElements.get('direct-to-checkout')) {
    class directToCheckout extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.parentFormComponent = this.closest('product-form-component');
            this.onetimePrice = this.querySelectorAll('[data-onetime-price]');
            this.items = this.parentFormComponent.collectItemsFromFormData();
            this.init();
        }

        variantQuantityUnsubscriber = undefined;

        connectedCallback() {
            this.variantQuantityUnsubscriber = subscribe('variant-quantity-change', (event) => {
                // Always call updateServing regardless of quantity value
                this.updatePricing(event.quantity);
            });
        }

        disconnectedCallback() {
            if (this.variantQuantityUnsubscriber) {
                this.variantQuantityUnsubscriber();
            }
        }

        updatePricing(qty) {
            const eachPriceOnetime = this.parentFormComponent.productData['each_price_onetime'];
            const currencySymbol = this.parentFormComponent.productData['currency_symbol'];

            if (qty === 0) {
                if (this.onetimePrice.length > 0) {
                    this.onetimePrice.forEach((price) => {
                        price.textContent = currencySymbol + (eachPriceOnetime * 1).toFixed(2);
                    });
                }
                return;
            }

            if (this.onetimePrice.length > 0) {
                this.onetimePrice.forEach((price) => {
                    price.textContent = currencySymbol + (eachPriceOnetime * qty).toFixed(2);
                });
            }
        }

        init() {
            const _this = this;
            this.form.addEventListener('submit', async (e) => {
                e.preventDefault();

                this.items = this.parentFormComponent.collectItemsFromFormData();

                if (this.items.length === 0) {
                    return;
                }

                // Build cart items string in Shopify's format
                const cartItems = this.items.map(item =>
                    `${item.id}:${item.quantity}`
                ).join(',');

                // Build checkout URL
                const baseUrl = window.Shopify.routes.root || '/';
                const checkoutUrl = `${baseUrl}cart/${cartItems}?checkout`;

                // Verify URL before redirect
                console.log('Redirecting to:', checkoutUrl);

                // Redirect immediately
                window.location.href = checkoutUrl;
            })
        }
    }

    customElements.define('direct-to-checkout', directToCheckout);
}

if (!customElements.get('variant-quantity-controls')) {
    class VariantQuantityControls extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', this.handleClick.bind(this));
            this.onloadInput();
        }

        disconnectedCallback() {
            this.onloadInput();
        }


        handleClick(e) {
            const _this = this;
            const button = e.target.closest('.quantity-minus, .quantity-plus');
            if (!button) return;

            const isMinus = button.classList.contains('quantity-minus');
            const container = button.closest('.quantity-selector');
            if (!container) return;

            const visibleInput = container.querySelector('.quantity-input');
            const hiddenInput = container.querySelector('input[type="hidden"][name*="[quantity]"]');

            if (!visibleInput || !hiddenInput) {
                console.error('Inputs not found in container:', container);
                return;
            }

            // Update current input value
            const currentValue = parseInt(visibleInput.value) || 0;
            const newValue = Math.max(0, currentValue + (isMinus ? -1 : 1));
            visibleInput.value = newValue.toString();
            hiddenInput.value = newValue.toString();

            // Calculate total quantity
            const totalQuantity = this.allQuantity();

            // Always publish the event, even when quantity is 0
            publish('variant-quantity-change', { quantity: totalQuantity, container: this.closest('product-form-component') });

            console.log(`Quantity updated to ${newValue} in container:`, container);
            console.log(`Total quantity: ${totalQuantity}`);
        }

        allQuantity() {
            const allQuantityInputs = this.closest('form').querySelectorAll('.quantity-input');
            let totalQuantity = 0;
            allQuantityInputs.forEach(input => {
                totalQuantity += parseInt(input.value) || 0;
            });
            return totalQuantity;
        }

        onloadInput() {
            const allQuantityInputs = this.closest('form').querySelectorAll('.quantity-input');
            allQuantityInputs.forEach(input => {
                input.value = input.getAttribute('data-default-value');
            });
        }
    }

    customElements.define('variant-quantity-controls', VariantQuantityControls);
}

if (!customElements.get('subscription-selector')) {
    class subscriptionSelector extends HTMLElement {
        constructor() {
            super();
            this.servingSize = this.getAttribute('data-serving-size');
            const optionJsonEl = this.querySelector('.product-option-json');
            try {
                this.productData = optionJsonEl ? JSON.parse(optionJsonEl.textContent) : {};
            } catch (e) {
                console.error('subscription-selector: invalid .product-option-json', e);
                this.productData = {};
            }
            this.onetimePrice = this.querySelectorAll('[data-onetime-price]');
            this.subscribePrice = this.querySelector('[data-subscribe-price]');
            this.freeProductBlocks = this.querySelector('.free-product-blocks');
            this.onetimeComparePrice = this.querySelectorAll('[data-onetime-compare-price]');
            this.onetimeCompareWrap = this.querySelectorAll('[data-onetime-compare-wrap]');
            this.saleBadge = this.querySelectorAll('[data-sale-badge]');
            this.salePercent = this.querySelectorAll('[data-sale-percent]');
        }

        variantQuantityUnsubscriber = undefined;
        variantChangeUnsubscriber = undefined;
        _lastQty = 1;
        _variantPrice = null;
        _variantServings = null;
        _variantComparePrice = null;
        _variantSubscribePrice = null;

        connectedCallback() {
            this.variantQuantityUnsubscriber = subscribe('variant-quantity-change', (event) => {
                this._lastQty = event.quantity;
                this.updateServing(event.quantity);
                this.updatePricing(event.quantity);
            });
            this.setFreeProductBlocksHeight();
            this._onResize = this.setFreeProductBlocksHeight.bind(this);
            window.addEventListener('resize', this._onResize, { passive: true });


            // Store initial variant data so qty changes use correct base price — no DOM update needed (Liquid already rendered correctly)
            const initialPrice = parseInt(this.getAttribute('data-initial-price'));
            const initialServings = parseInt(this.getAttribute('data-initial-servings'));
            const initialComparePrice = parseInt(this.getAttribute('data-initial-compare-price'));
            if (!isNaN(initialPrice)) {
                this._variantPrice = initialPrice;
                this._variantServings = initialServings;
            }
            if (!isNaN(initialComparePrice)) {
                this._variantComparePrice = initialComparePrice;
            }
            const initialSubscribePrice = parseInt(this.getAttribute('data-initial-subscribe-price'));
            if (!isNaN(initialSubscribePrice)) {
                this._variantSubscribePrice = initialSubscribePrice;
            }

            // Subscribe to variant changes to show/hide based on selling plan availability
            const sectionId = this.closest('product-info')?.dataset.section;
            const variantDataEl = sectionId ? document.getElementById(`variant-data-${sectionId}`) : null;
            if (variantDataEl) {
                this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data: { selectedOptionValues } }) => {
                    const variants = JSON.parse(variantDataEl.textContent);
                    const matched = variants.find((v) =>
                        v.optionValueIds.length === selectedOptionValues.length &&
                        selectedOptionValues.every((id) => v.optionValueIds.includes(id))
                    );
                    if (!matched) return;
                    this.toggleSubscribeBlock(matched.hasSellingPlan);
                    this.updateVariantPricing(matched.price, matched.servings, matched.hasSellingPlan, matched.compareAtPrice, matched.subscribePrice);
                    const perDayText = matched.isVarietyPack ? 'Drinks (4 flavors)' : this.dataset.perDayText;
                    this.querySelectorAll('[data-per-day-text]').forEach(el => el.textContent = perDayText);
                });
            }
        }

        disconnectedCallback() {
            if (this.variantQuantityUnsubscriber) {
                this.variantQuantityUnsubscriber();
            }
            if (this.variantChangeUnsubscriber) {
                this.variantChangeUnsubscriber();
            }
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
                this._onResize = null;
            }
        }

        toggleSubscribeBlock(show) {
            const wrapper = this.querySelector('.subscribe-block-wrapper');
            if (!wrapper) return;

            if (show) {
                if (wrapper.style.height !== '0px') return;
                // Disable transition, lift height constraint, measure, snap back, re-enable, animate
                wrapper.style.transition = 'none';
                wrapper.style.height = '';
                const targetHeight = wrapper.offsetHeight;
                wrapper.style.height = '0px';
                wrapper.offsetHeight; // force reflow so browser commits 0px before transition re-enables
                wrapper.style.transition = '';
                wrapper.style.height = targetHeight + 'px';
                wrapper.style.opacity = '1';
                wrapper.style.pointerEvents = '';
                const onEnd = (e) => {
                    if (e.propertyName !== 'height') return;
                    wrapper.style.height = '';
                    wrapper.removeEventListener('transitionend', onEnd);
                };
                wrapper.addEventListener('transitionend', onEnd);
                wrapper.querySelector('label.featured-product-form')?.click();
            } else {
                if (wrapper.style.height === '0px') {
                    this.querySelector('label[for="selling_plan_onetime"]')?.click();
                    return;
                }
                wrapper.style.height = wrapper.offsetHeight + 'px';
                requestAnimationFrame(() => {
                    wrapper.style.height = '0px';
                    wrapper.style.opacity = '0';
                    wrapper.style.pointerEvents = 'none';
                });
                this.querySelector('label[for="selling_plan_onetime"]')?.click();
            }
        }

        setFreeProductBlocksHeight() {
            if (this.freeProductBlocks) {
                // Measure natural height
                this.freeProductBlocks.style.height = 'auto';
                const height = this.freeProductBlocks.scrollHeight;

                // Expose as CSS variable on :root
                document.documentElement.style.setProperty('--section-height', height + 'px');
            }
        }


        updateVariantPricing(priceInCents, servings, hasSellingPlan = true, compareAtPriceInCents = 0, subscribePriceInCents = 0) {
            this._variantPrice = priceInCents;
            this._variantServings = servings;
            this._variantComparePrice = compareAtPriceInCents;
            this._variantSubscribePrice = subscribePriceInCents;
            this.updatePricing(this._lastQty, hasSellingPlan);
        }

        // Sale state is whatever Shopify says it is: compare_at_price > price.
        // Nothing here computes a discounted price, so displayed price can't drift from charged price.
        updateSaleState(qty) {
            const effectiveQty = qty === 0 ? 1 : qty;
            const price = this._variantPrice;
            const compareAt = this._variantComparePrice;
            const onSale = Boolean(compareAt) && Boolean(price) && compareAt > price;

            if (onSale) {
                const compareTotal = ((compareAt / 100) * effectiveQty).toFixed(2);
                this.onetimeComparePrice.forEach((el) => {
                    el.textContent = compareTotal;
                });
                const percent = Math.round(((compareAt - price) / compareAt) * 100);
                this.salePercent.forEach((el) => {
                    el.textContent = percent;
                });
            }

            this.onetimeCompareWrap.forEach((el) => el.classList.toggle('hidden', !onSale));
            this.saleBadge.forEach((el) => el.classList.toggle('hidden', !onSale));
        }

        updatePricing(qty, updateSubscribe = true) {
            const effectiveQty = qty === 0 ? 1 : qty;

            const baseOnetime = this._variantPrice !== null
                ? this._variantPrice / 100
                : this.productData['each_price_onetime'];

            // Subscription price is whatever Shopify's selling plan allocation says,
            // so it holds for percentage and absolute plans alike. The percentage
            // metafield is only reached when no allocation made it to the client.
            let baseSubscribe;
            if (this._variantSubscribePrice !== null && this._variantSubscribePrice > 0) {
                baseSubscribe = this._variantSubscribePrice / 100;
            } else {
                const percentage = this.productData['percentage'] || 0;
                baseSubscribe = baseOnetime * (1 - percentage / 100);
            }
            const servings = this._variantServings !== null
                ? this._variantServings
                : parseInt(this.servingSize);

            if (this.onetimePrice.length > 0) {
                this.onetimePrice.forEach((el) => {
                    el.textContent = (baseOnetime * effectiveQty).toFixed(2);
                });
            }
            if (updateSubscribe && this.subscribePrice) {
                this.subscribePrice.textContent = (baseSubscribe * effectiveQty).toFixed(2);
            }

            // The saving claim in the benefits copy tracks the same baseline as the
            // struck-through price: compare-at while on sale, the one-time price
            // otherwise, so the two figures can never contradict each other.
            if (updateSubscribe) {
                const comparePrice = this._variantComparePrice;
                const savingBaseline = comparePrice && comparePrice > this._variantPrice
                    ? comparePrice / 100
                    : baseOnetime;
                const saving = Math.max(0, savingBaseline - baseSubscribe);
                this.querySelectorAll('[data-subscribe-saving]').forEach((el) => {
                    el.textContent = '$' + (saving * effectiveQty).toFixed(2);
                });
            }

            this.updateSaleState(qty);

            document.querySelectorAll('[data-servings]').forEach((el) => {
                el.textContent = servings * effectiveQty;
            });

            const unit = this.getAttribute('data-drink-unit') || 'drink';
            const onetimePerDrink = (baseOnetime / servings).toFixed(2);
            document.querySelectorAll('[data-onetime-per-drink]').forEach((el) => {
                el.textContent = `($${onetimePerDrink} / ${unit})`;
            });
            if (updateSubscribe) {
                const subscribePerDrink = (baseSubscribe / servings).toFixed(2);
                document.querySelectorAll('[data-subscribe-per-drink]').forEach((el) => {
                    el.textContent = `($${subscribePerDrink} / ${unit})`;
                });
            }
        }

        updateServing(qty) {
            const serving = document.querySelectorAll('[data-servings]');
            console.log('Received quantity:', qty);

            if (serving) {
                serving.forEach((item) => {
                    if (qty === 0) {
                        return
                    }

                    item.textContent = (qty * this.servingSize);
                });
            }
        }
    }

    customElements.define('subscription-selector', subscriptionSelector);
}

if (!customElements.get('free-product-selector')) {

    class FreeProductSelector extends HTMLElement {
        constructor() {
            super();
            this.productID = this.getAttribute('data-product-id');
            this.variantSelector = this.querySelector('select');
            this.variantInput = this.querySelector('input[name="free-product-id"]');
            this.init();

            window.addEventListener('pageshow', function () {
                if (!this.variantSelector) return;
                this.variantSelector.selectedIndex = -1;
            });
        }

        init() {
            const _this = this;
            this.variantSelector.value = '';
            this.variantSelector.addEventListener('change', (e) => {
                _this.variantInput.value = e.target.value;
            });
        }
    }

    customElements.define('free-product-selector', FreeProductSelector);
}

if (!customElements.get('product-price-switcher')) {
    class ProductPriceSwitcher extends HTMLElement {
        constructor() {
            super();
            this.productData = JSON.parse(this.querySelector('.product-option-json').textContent);
            this.dataPriceAll = this.querySelectorAll('[data-price]');
            this.currencySymbol = this.getAttribute('data-currency-symbol');
        }

        variantQuantityUnsubscriber = undefined;

        connectedCallback() {
            this.variantQuantityUnsubscriber = subscribe('variant-quantity-change', (event) => {
                // Always call updateServing regardless of quantity value
                this.updatePricing(event.quantity, event.container);
            });
        }

        disconnectedCallback() {
            if (this.variantQuantityUnsubscriber) {
                this.variantQuantityUnsubscriber();
            }
        }

        updatePricing(qty, container) {
            const _this = this;
            const dataPriceBlock = container.querySelector('[data-price-block]');
            if (qty === 0) {
                dataPriceBlock.querySelector('[data-empty-text]').classList.remove('hide');
                dataPriceBlock.querySelectorAll('[data-price]').forEach((price) => {
                    price.classList.add('hide');
                });
                return;
            }

            dataPriceBlock.querySelector('[data-empty-text]').classList.add('hide');
            dataPriceBlock.querySelectorAll('[data-price]').forEach((price) => {
                price.classList.remove('hide');
            });

            if (dataPriceBlock.hasAttribute('data-onetime')) {
                dataPriceBlock.querySelector('[data-regular-price]').textContent = _this.currencySymbol + (_this.productData['each_price_onetime'] * qty).toFixed(2);
            } else {
                dataPriceBlock.querySelector('[data-compare-price]').textContent = _this.currencySymbol + (_this.productData['full_price_subscribe'] * qty).toFixed(2);
                dataPriceBlock.querySelector('[data-regular-price]').textContent = _this.currencySymbol + (_this.productData['each_price_subscribe'] * qty).toFixed(2);
                dataPriceBlock.querySelector('[data-save-price]').textContent = _this.currencySymbol + Math.round((_this.productData['full_price_subscribe'] - _this.productData['each_price_subscribe']) * qty);
            }
        }
    }

    customElements.define('product-price-switcher', ProductPriceSwitcher);
}

if (!customElements.get('upsell-products')) {
class UpsellProducts extends HTMLElement {
    constructor() {
        super();
        this.slider;
        this.upsellSlider = this.querySelector('.upsell-slider');

        this.initSlider();

    }

    initSlider() {
        const sliderConfig = {
            slides: {
                perView: 'auto',
                spacing: 10
            }
        }
        this.slider = new KeenSlider(this.upsellSlider, sliderConfig);
    }
}


    customElements.define('upsell-products', UpsellProducts);
}


if (!customElements.get('cart-reviews-slider')) {
    class CartReviewsSlider extends HTMLElement {
        constructor() {
            super();
            this.slider = null;
            this.sliderEl = this.querySelector('[data-cart-reviews-slider]');
            this.dotsEl = this.querySelector('[data-cart-reviews-dots]');
        }

        connectedCallback() {
            if (!this.sliderEl) return;

            if (typeof KeenSlider === 'undefined') {
                setTimeout(() => this.connectedCallback(), 100);
                return;
            }

            if (this.slider) return;

            this.slider = new KeenSlider(this.sliderEl, {
                loop: true,
                mode: 'snap',
                slides: { perView: 1, spacing: 10 },
                created: (slider) => {
                    this.updateDots(slider.track.details.rel);
                    this.attachDotHandlers(slider);
                },
                slideChanged: (slider) => {
                    this.updateDots(slider.track.details.rel);
                },
            });
        }

        disconnectedCallback() {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
        }

        updateDots(activeIdx) {
            if (!this.dotsEl) return;

            const dots = this.dotsEl.querySelectorAll('[data-dot]');
            dots.forEach((dot) => {
                const idx = parseInt(dot.getAttribute('data-dot') || '0', 10);
                dot.setAttribute('aria-current', idx === activeIdx ? 'true' : 'false');
            });
        }

        attachDotHandlers(slider) {
            if (!this.dotsEl) return;
            if (this.dotsEl.hasAttribute('data-dots-bound')) return;

            this.dotsEl.setAttribute('data-dots-bound', 'true');
            this.dotsEl.addEventListener('click', (e) => {
                const btn = e.target.closest('[data-dot]');
                if (!btn) return;
                const idx = parseInt(btn.getAttribute('data-dot') || '0', 10);
                slider.moveToIdx(idx);
            });
        }
    }

    customElements.define('cart-reviews-slider', CartReviewsSlider);
}